var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reply-btn",attrs:{"title":"ответить"},on:{"click":function($event){$event.stopPropagation();return _vm.onClickBtn.apply(null, arguments)}}},[_vm._v("←")])
}
var staticRenderFns = []

export { render, staticRenderFns }